import { observer } from 'mobx-react-lite'
import { MessagePreview } from 'widgets/MessagePreview'
import { useBroadcastViewContext } from 'pages/broadcasts/ui/BroadcastView/context/broadcastViewContext'

export const BroadcastViewPreview = observer(() => {
  const { type, broadcastSMSStore, ringlessMessageFieldStore } = useBroadcastViewContext()
  const messageFieldStore = broadcastSMSStore.messageFieldStore
  const attachment = ringlessMessageFieldStore.attachment

  return <MessagePreview type={type} messageStore={messageFieldStore} attachment={attachment} />
})
